import './TextWith2Pictures.scss';
import { safeHtml } from '../../../../services/helpers';
import StrapiImageWithSkeleton from '../../../../components/StrapiImageWithSkeleton/StrapiImageWithSkeleton';
import { useMediaQuery } from 'react-responsive';

export default function TextWith2Pictures({ content }) {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    return (
        <div className='workshop-text_with_2_pictures'>
            {
                !isMobile &&
                <div className="workshop-text_with_2_pictures__image-container circles1">
                    <div className="workshop-text_with_2_pictures__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={content.Photo1}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="workshop-text_with_2_pictures__image-shadow"></div>
                </div>
            }
            <div className="workshop-text_with_2_pictures__block_text" dangerouslySetInnerHTML={safeHtml(content.Texte2)} />
            {
                !isMobile &&
                <div className="workshop-text_with_2_pictures__image-container circles2">
                    <div className="workshop-text_with_2_pictures__image-wrapper">
                        <StrapiImageWithSkeleton
                            picture={content.Photo2}
                            loading="lazy"
                            size='small'
                        />
                    </div>
                    <div className="workshop-text_with_2_pictures__image-shadow"></div>
                </div>
            }
        </div>
    )
}